import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link, Redirect, withRouter } from "react-router-dom";

import axios from "axios";

import EUFleets from '../../EndUser/EUFleets';
import EUDefaultBanner from '../../EndUser/EUDefaultBanner';
import Navbar from '../../EndUser/EU-Navbar.jsx';
import EUSidebar from '../../EndUser/EUSidebar';
import ModalRoutes from '../../Pages/ModalRoutes';
import EUBookingPullout from '../../EndUser/EUBookingPullout';

import { LoadingIcon } from '../../Common/Loading_Icon';
import { checkCredentials } from '../../../Helpers/checkCredentials';
import { Trans } from 'react-i18next';
import i18n from '../../../i18n';
import moment from 'moment';

class EUHome extends Component {

    constructor(props) {
        super(props);

        this.state = { 
            loading: true,
            sh_list: [],
            bookings: [], 
            outstanding_bookings: [],
            filters: {},
            searching: false,
        };

        this.updateFleets = this.updateFleets.bind(this);
        this.navigateToVehicles = this.navigateToVehicles.bind(this);
        this.openCovid = this.openCovid.bind(this);
    }

    componentDidMount() {
        document.title = "Home - FleetXPress"
        var self = this;
        axios.get('/ajax/apply')
        .then(function(response) {
            checkCredentials(response);
            if('redirect' in response?.data)
            {
                self.props.history.push(('/' + response?.data.redirect));
                window.location.reload(true);
            }
            else
            {
                if (! ("status" in response?.data)) {
                    
                    self.setState({
                        loading: false,
                        sh_list: response?.data.stakeholders,
                    })
                }
            }
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    updateFleets() {
        var self = this;
        axios.get('/ajax/apply/update')
        .then(function(response) {
            checkCredentials(response);
            self.setState({
                sh_list: response?.data.stakeholders
            })
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    navigateToVehicles() {
        this.props.history.push("/vehicles/" + this.state.sh_list.approved[0].Company.toLowerCase().replace(/\s/g,'') + "/" + this.state.sh_list.approved[0].Division.toLowerCase().replace(/\s/g,''));
    }

    toggleSidebar() {
        const sidebar = document.getElementById('eu-sidebar');
        const openBtn = document.getElementById('open-sidebar-btn');
        if (!sidebar || !openBtn) return;

        sidebar.classList.toggle("is-active");
        openBtn.classList.toggle("is-active");

        if(openBtn.innerHTML === '<i class="fas fa-chevron-right"></i>') {
            openBtn.innerHTML = '<i class="fas fa-chevron-left"></i>';
        } else {
            openBtn.innerHTML = '<i class="fas fa-chevron-right"></i>';
        }
    }

    openCovid() {
        var base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/covid-update');
    }

    render() {        
        return (
            <div>
                <Navbar history={this.props.history} match={this.props.match} location={this.props.location} />
                <div className="container flex eu-container">
                    {/* <div className="open-sidebar-btn" id = "open-sidebar-btn" onClick = {this.toggleSidebar}>
                        <i className="fas fa-chevron-right"></i>
                    </div> */}

                    {/*Sidebar Section*/}
                    <EUSidebar history={this.props.history} match={this.props.match} location={this.props.location}/>

                    {/*Main Section*/}
                    <div className="eu-mainsection">

                        {/*Banner*/}
                        {/* <div className="covid-19-banner">
                            <div className="covid-text">
                                <Trans key={"Integrated Automotive is keeping you safe with our enhanced Covid-19 Processes"["For details,"]}>Integrated Automotive is keeping you safe with our enhanced Covid-19 Processes. For details,</Trans> <a onClick={this.openCovid}><Trans>click here</Trans>.</a>  
                            </div>
                        </div> */}
                        <EUDefaultBanner history={this.props.history} match={this.props.match} loading={this.state.loading} navigateToVehicles={this.navigateToVehicles} />
                        <div className="eu-mainsection-wrapper">
                            <EUFleets history={this.props.history} match={this.props.match} loading={this.state.loading} sh_list={this.state.sh_list} update_fleets={this.updateFleets} key={ !this.state.loading ? ("a" + this.state.sh_list.approved.length + "s" + this.state.sh_list.survey.length + "i" + this.state.sh_list.invitaion.length + "a" + this.state.sh_list.application.length + "p" + this.state.sh_list.pending.length + "o" + this.state.sh_list.onhold.length) : ""} />
                        </div>
                    </div>
                </div>
                <ModalRoutes match={this.props.match} history={this.props.history}/>
                <EUBookingPullout history={this.props.history} match={this.props.match} location={this.props.location}/>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    endUser: store.endUser
})

export default connect(mapStateToProps)(EUHome)